/* ==========================================================
   ELUSA CART EMPTY DISCOUNT
   Aktive Rabattcodes im leeren Warenkorb anzeigen und entfernen
   (snippets/cart-empty-discount.liquid).

   Ein leerer Warenkorb hat keine discount_applications, die Codes
   stehen aber in /cart.js unter discount_codes. Ein /discount/CODE-
   Link setzt ausserdem das Cookie discount_code, das Shopify an der
   Kasse wieder anwendet - beim Entfernen wird es darum mit geloescht.
   ========================================================== */

(() => {
  if (customElements.get('cart-empty-discount')) return;

  const root = () =>
    (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function readCookieCode() {
    const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  // Shopify setzt das Cookie je nach Shop auf den Host oder die Hauptdomain
  function clearCookieCode() {
    const host = window.location.hostname;
    const domains = ['', host, '.' + host.replace(/^www\./, '')];
    domains.forEach((domain) => {
      document.cookie = 'discount_code=; Max-Age=0; path=/' + (domain ? '; domain=' + domain : '');
    });
  }

  class CartEmptyDiscount extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-remove]');
        if (button) this.removeCode(button);
      });
      this.load();
    }

    async load() {
      let codes = [];
      try {
        const res = await fetch(root() + 'cart.js', { cache: 'no-store' });
        const cart = await res.json();
        if (cart.item_count > 0) return;
        codes = (cart.discount_codes || []).map((discount) => discount.code).filter(Boolean);
      } catch (e) {
        return;
      }

      const cookieCode = readCookieCode();
      if (cookieCode && !codes.some((code) => code.toLowerCase() === cookieCode.toLowerCase())) {
        codes.push(cookieCode);
      }

      this.codes = codes;
      this.render();
    }

    render() {
      const list = this.querySelector('[data-codes]');
      const template = this.querySelector('template[data-chip]');
      list.replaceChildren(...this.codes.map((code) => {
        const chip = template.content.firstElementChild.cloneNode(true);
        chip.querySelector('[data-code]').textContent = code;
        chip.querySelector('[data-remove]').dataset.code = code;
        return chip;
      }));
      this.hidden = this.codes.length === 0;
    }

    async removeCode(button) {
      const code = button.dataset.code;
      const remaining = this.codes.filter((other) => other.toLowerCase() !== code.toLowerCase());
      button.disabled = true;

      try {
        await fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remaining.join(',') })
        });
      } catch (e) {
        button.disabled = false;
        return;
      }

      if (readCookieCode().toLowerCase() === code.toLowerCase()) clearCookieCode();
      if (remaining.length === 0 && typeof window.co2 !== 'undefined' && window.co2.removeDiscountCode) {
        try { await window.co2.removeDiscountCode(); } catch (e) {}
      }

      this.codes = remaining;
      this.render();
    }
  }

  customElements.define('cart-empty-discount', CartEmptyDiscount);
})();
